
import { Avatar, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import BOTTLE_IMG from "assets/icons/bottle.svg";
import { Typography } from "components/ui";
import React from "react";
import { randomB } from "shared/palettes";
import { GamePaper } from "../styled";

const SpinPlayer = ({
    step,
    isMobile,
    players,
    userName,
    luckyUser,
    rotationPlayer,
    handleSpinPlayer,
    isDone,
}) => {
    const radius = isMobile ? 65 : 140;

    return (
        <GamePaper active={step === 1}>
            <Typography $bolds color={step === 1 ? "primary" : "textSecondary"}>
                1. สุ่มหาผู้โชคดี
            </Typography>
            <Box
                sx={{
                    position: "relative",
                    height: isMobile ? 220 : 400,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Box
                    component="img"
                    src={BOTTLE_IMG}
                    onClick={handleSpinPlayer}
                    sx={{
                        width: isMobile ? 100 : 200,
                        transition: "transform 3s cubic-bezier(0.15, 0, 0.15, 1)",
                        transform: `rotate(${rotationPlayer}deg)`,
                        zIndex: 10,
                        cursor: step >= 2 && !isDone ? "default" : "pointer",
                    }}
                />
                {players.map((p, i) => {
                    const angle = (i / players.length) * 2 * Math.PI - Math.PI / 2;
                    return (
                        <Box
                            key={p.id}
                            sx={{
                                position: "absolute",
                                transform: `translate(${Math.cos(angle) * radius}px, ${Math.sin(angle) * radius
                                    }px)`,
                                textAlign: "center",
                                justifyItems: "center",
                                zIndex: 20,
                            }}
                        >
                            <Avatar
                                sx={{
                                    width: isMobile ? 30 : 45,
                                    height: isMobile ? 30 : 45,
                                    bgcolor: randomB[i % 20],
                                    border: luckyUser?.id === p.id ? "3px solid gold" : "2px solid white",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                }}
                            >
                                {p.name[0]}
                            </Avatar>
                            <Typography sx={{ fontSize: "0.6em", fontWeight: "bold", mt: 0.5 }}>
                                {p.name === userName ? "Me" : p.name}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>
        </GamePaper>
    );
};

export default SpinPlayer;
